import React from 'react'
import {Box, Text, Flex, Link} from '@chakra-ui/react'
import {WarningIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'

import {PencilWritingIcon} from '../../../icons'
import {useRails} from '../../../contexts/rails'
import {requestSupplierAgreement} from '../../../../api'

export const stepName = 'signAgreement'

const calculateStatus = ({
  submittedRequest,
  supplierAgreementRequested,
  supplierAgreementAccepted,
  requestFailed,
}) => {
  if (supplierAgreementAccepted) {
    return 'completed'
  }
  if (submittedRequest || supplierAgreementRequested) {
    return 'emailed'
  }
  if (requestFailed) {
    return 'declined'
  }

  return 'incomplete'
}

const ErrorNotification = () => {
  const {t} = useTranslation('cashinStepper')

  return (
    <Flex alignItems="start">
      <WarningIcon boxSize="13px" color="red.600" mt="xxs" mr="xxs" />
      <Box>
        <Text textStyle="body-small">
          {t('steps.signAgreement.error.message')}
        </Text>
        <Text textStyle="body-small">
          {t('steps.signAgreement.error.contact')}{' '}
          <Link
            href="mailto:support@withmarmalade.com"
            isExternal
            color="mld.primary.100"
          >
            {t('steps.signAgreement.error.support')}
          </Link>
        </Text>
      </Box>
    </Flex>
  )
}

const notificationFor = ({requestFailed}) =>
  requestFailed ? <ErrorNotification /> : undefined

export default (stepperData) => {
  const {t} = useTranslation('cashinStepper')
  const {authenticityToken} = useRails()
  const [submittedRequest, setSubmittedRequest] = React.useState(false)
  const [requestFailed, setRequestFailed] = React.useState(false)

  const onClick = async () => {
    try {
      setRequestFailed(false)
      await requestSupplierAgreement({
        supplierId: stepperData.supplierId,
        authenticityToken,
      })

      setSubmittedRequest(true)
    } catch {
      setRequestFailed(true)
    }
  }

  const status = calculateStatus({
    ...stepperData,
    submittedRequest,
    requestFailed,
  })

  return {
    name: stepName,
    visible: true,
    status,
    active: status === 'incomplete',
    icon: <PencilWritingIcon />,
    title: t('steps.signAgreement.title'),
    subtitle: {default: t('steps.signAgreement.subtitle')},
    notification: notificationFor({requestFailed}),
    action: {
      label: t('steps.signAgreement.actionLabel'),
      onClick,
    },
  }
}
